function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip771)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.35447 0.882779C3.54859 0.711529 3.56719 0.415342 3.39591 0.221185C3.22469 0.0270291 2.92844 0.00846656 2.73428 0.179717C1.01647 1.69494 0.03125 3.87331 0.03125 6.15625C0.03125 6.41512 0.241125 6.625 0.5 6.625C0.758875 6.625 0.96875 6.41512 0.96875 6.15625C0.96875 4.14222 1.83831 2.22012 3.35447 0.882779ZM13.2657 0.179717C13.0715 0.00846656 12.7753 0.0270603 12.6041 0.221185C12.4328 0.415342 12.4514 0.711529 12.6455 0.882779C14.1617 2.22012 15.0312 4.14222 15.0312 6.15625C15.0312 6.41512 15.2411 6.625 15.5 6.625C15.7589 6.625 15.9688 6.41512 15.9688 6.15625C15.9688 3.87331 14.9835 1.69494 13.2657 0.179717ZM4.03556 1.53156C2.68234 2.69309 1.90625 4.37872 1.90625 6.15625C1.90625 6.41512 2.11613 6.625 2.375 6.625C2.63387 6.625 2.84375 6.41512 2.84375 6.15625C2.84375 4.6525 3.50069 3.22615 4.64616 2.24294C4.84259 2.07431 4.86516 1.77837 4.69653 1.58194C4.52791 1.38547 4.23194 1.36294 4.03556 1.53156ZM11.9644 1.53156C11.768 1.36294 11.4721 1.3855 11.3035 1.58194C11.1348 1.77837 11.1574 2.07431 11.3538 2.24294C12.4993 3.22615 13.1562 4.6525 13.1562 6.15625C13.1562 6.41512 13.3661 6.625 13.625 6.625C13.8839 6.625 14.0938 6.41512 14.0938 6.15625C14.0938 4.37872 13.3177 2.69309 11.9644 1.53156ZM8.9375 13.1875H7.0625C6.80363 13.1875 6.59375 13.3974 6.59375 13.6562V14.5938C6.59375 15.3692 7.22459 16 8 16C8.77541 16 9.40625 15.3692 9.40625 14.5938V13.6562C9.40625 13.3974 9.19637 13.1875 8.9375 13.1875Z",
  fill: "url(#paint0_linear771)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9562 13.3247C12.8356 12.2042 12.2185 10.7143 12.2185 9.12959V6.15625C12.2185 3.98847 10.575 2.19763 8.46855 1.96369V0.46875C8.46855 0.209875 8.25867 0 7.9998 0C7.74092 0 7.53105 0.209875 7.53105 0.46875V1.96369C5.42461 2.19763 3.78105 3.98847 3.78105 6.15625V9.12959C3.78105 10.7143 3.16395 12.2041 2.04342 13.3247C1.75333 13.6146 1.95142 14.125 2.3748 14.125H13.6248C14.047 14.125 14.247 13.6154 13.9562 13.3247Z",
  fill: "url(#paint1_linear771)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear771",
  x1: 8,
  y1: 16,
  x2: 8,
  y2: 0.0624981,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F99525"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.50193,
  stopColor: "#F9A825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9A825"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear771",
  x1: 7.99983,
  y1: 14.125,
  x2: 7.99983,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F98D25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9A825"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip771"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgBellOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOrange);
export default __webpack_public_path__ + "static/media/bellOrange.3eaf2555.svg";
export { ForwardRef as ReactComponent };